// extracted by mini-css-extract-plugin
export default {"hyperLink":"WorkOrdersPage_hyperLink__VPx5w"};